import { settings } from 'settings';
import Fetch from 'utils/fetch';

export interface ShopArray {
  id?: number;
  shopName?: string;
}

export interface CourierObj {
  id?: number;
  firstName?: string;
  lastName?: string;
  notes?: string;
}

export interface InboundInfoFormatted {
  id: string;
  name: string;
  shopArray: ShopArray[];
  courier: CourierObj;
}

export interface CourierAreaFormatted {
  areaList: string[];
  courier: CourierObj;
  notes: string;
}

export async function fetchInbound(): Promise<InboundInfoFormatted[]> {
  try {
    const response: Response = await Fetch.get({
      url: `${settings.newApiUrl}/inbound/getAllInboundInfoFormatted`,
    });

    if (response.ok) {
      const InboundInfoList: InboundInfoFormatted[] = await response.json();
      return InboundInfoList;
    }
  } catch (error) {
    return [];
  }
}

export async function fetchCourierArea(): Promise<CourierAreaFormatted[]> {
  try {
    const response: Response = await Fetch.get({
      url: `${settings.newApiUrl}/courier/getAllCourierAreaFormatted`,
    });

    if (response.ok) {
      const InboundInfoList: CourierAreaFormatted[] = await response.json();
      return InboundInfoList;
    }
  } catch (error) {
    return [];
  }
}

export interface InboundInfo {
  id: string;
  name: string;
  account_ids?: number[];
  assigned_courier_id?: number;
}
